// @ts-strict-ignore
import Link from 'next/link';
import styled from 'styled-components';
import { UserCard } from 'src/modules/community/communityAbout/components/userCard';
import { useSelector } from 'src/store/store';
import i18n from 'src/utils/translate';
import { helpScoutArticle } from 'src/utils/helpScoutBeacon';
import { trackFootfallEvent } from 'src/utils/footfall';
import { Event, Section } from 'src/constants/footfall';
import ContactAdmins from 'src/components/buttons/contactAdmins';
import Title from 'src/modules/community/communityAbout/components/title';
import Description from 'src/modules/community/communityAbout/components/description';
import GuidelinesHighlights from 'src/modules/community/communityAbout/components/guidelinesHighlights';
import Spacer from 'src/components/spacer';
import { Subtitle, SupportingMembers } from 'src/modules/community/communityAbout/components/sharedStyles';
import { LinkButton } from 'styles-js/buttons';
import { communityAdminRoles } from 'src/constants/roles';
import { textLinkPrimary } from 'styles-js/mixins/typography';
import Icon from 'src/components/icon';

export default function MainContent(): JSX.Element {
  const { supportingMembers } = useSelector(({ pages }) => pages.communityAbout);
  const { slug, isArchived } = useSelector(({ context }) => context.currentCommunity);

  return (
    <Container>
      <Title />
      <Description />
      <GuidelinesHighlights />
      <div id="whoweare">
        <Subtitle>{i18n.t('Moderation team')}</Subtitle>
        {supportingMembers?.length === 0 && (
          <>
            <p>
              {i18n.t('This community is currently being moderated by HealthUnlocked: reports of abuse are reviewed and actioned when appropriate.')}{' '}
              <LinkButton onClick={() => helpScoutArticle('193-communities-moderated-by-healthunlocked')}>{i18n.t('Learn how')}{' >'}</LinkButton>
            </p>
            <Spacer />
          </>
        )}
        <ContactAdmins
          admins={supportingMembers.filter(member => communityAdminRoles.includes(member.role))}
          section={Section.CommunityAbout}
        />
        {supportingMembers?.length > 0 && (
          <>
            <Spacer />
            <SupportingMembers>
              {supportingMembers.map(({ username, userImageHash, role }) => (
                <UserCard
                  key={username}
                  role={role}
                  userImageHash={userImageHash}
                  username={username}
                />
              ))}
            </SupportingMembers>
            {!isArchived && (
              <Link
                legacyBehavior
                passHref
                href={`/${slug}/members`}
              >
                <SeeMoreLink onClick={() => {
                  trackFootfallEvent(Event.Clicked, {
                    clickType: 'see-all-members',
                    clickMetadata: { section: Section.CommunityAbout },
                  });
                }}
                >
                  {i18n.t('View all community members')}
                  <Icon icon="open-right" />
                </SeeMoreLink>
              </Link>
            )}
          </>
        )}
      </div>
    </Container>
  );
}

const Container = styled.div`
  @media (${({ theme }) => theme.underScreenSmall}) {
    padding: 0 15px;
    margin-bottom: 30px;
  }
`;

const SeeMoreLink = styled.a`
  ${textLinkPrimary};
  display: block;
  margin-top: 10px;
`;
